<template>
  <q-page padding>
    <PageHeader
      title="Configurações de Alertas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <q-card class="q-mt-md">
      <q-card-section class="row align-center justify-between">
        <p class="text-h6">Segurança Emocional</p>
        <q-btn
          color="positive"
          icon="add"
          no-caps
          label="Configurar alerta"
          @click="configurarAlerta"
        />
      </q-card-section>
      <q-separator />
      <q-card-section class="row justify-around">
        <div class="column">
          <p class="text-h6 text-bold q-mb-lg">Notificar</p>

          <q-radio
            v-for="(unidades, index) in $store.state.org.todaUnidades"
            :key="index"
            size="sm"
            v-model="active"
            :val="unidades.id"
            :label="unidades.nome"
          />
        </div>
        <div class="column">
          <p class="text-h6 text-bold q-mb-lg">Selecione os Estados</p>
          <q-select
            dense
            v-model="nivel"
            :options="optionsSelecao"
            :disable="active.length == 0"
            outlined
            label="Estados"
          />
        </div>
        <div class="column">
          <p class="text-h6 text-bold q-mb-lg">
            Estados Emocionais ja configurados
          </p>
          <q-select
            v-for="(unidades, index) in configurados"
            :key="index"
            dense
            v-model="unidades.nivelMax"
            :options="options"
            :disable="true"
            :label="unidades.unidadeNome"
            outlined
          />
        </div>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import { inject } from "vue";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const keycloak = inject("keycloak");
    const active = ref("");
    const nivel = ref("");
    const store = useStore();
    const configurados = ref([]);
    const $q = useQuasar();

    const configurarAlerta = async () => {
      try {
        await store.dispatch("cse/setAlerta", {
          nivelMax: nivel.value.value,
          matricula: keycloak.subject,
          unidadeId: active.value,
        });

        $q.notify({
          message: "Alerta configurado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getConfiguracao();
      } catch (error) {
        $q.notify({
          message: "Erro a o configurar alerta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getConfiguracao = async () => {
      try {
        const response = await store.dispatch("cse/getAlerta", {
          matricula: keycloak.subject,
        });
        configurados.value = response.data.resultado.dados;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar alertas configurados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getConfiguracao);

    return {
      optionsSelecao: [
        {
          label: "Otimo",
          value: 5,
        },
        {
          label: "Bem",
          value: 4,
        },
        {
          label: "Regular",
          value: 3,
        },
        {
          label: "Ruim",
          value: 2,
        },
        {
          label: "Pessimo",
          value: 1,
        },
      ],
      options: ["Otimo", "Bem", "Regular", "Ruim", "Pessimo"],
      active,
      nivel,
      configurarAlerta,
      getConfiguracao,
      configurados,
    };
  },
};
</script>
